import { useTranslationWithNamespace } from '@gov-nx/core/service';
import type { PageCode } from '@gov-nx/module/page';
import { useKdeOMneStatVedeUdajeContext } from '@gov-nx/module/page';
import { ContentLayout, InfoBanner, LayoutGap } from '@gov-nx/ui/web';
import { AgendaItem } from './AgendaItem';
import { AgendasSkeleton } from './AgendasSkeleton';
import { AisSkeleton } from './AisSkeleton';
import { AisView } from './AisView';

type AgendasViewProps = {
	code: PageCode;
};

export const AgendasView = ({ code }: AgendasViewProps) => {
	const { data, controls, expandedAis, aisData } =
		useKdeOMneStatVedeUdajeContext();
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const ts = getLocalizeCurried(code);

	if (controls.initialLoading) {
		return <AgendasSkeleton />;
	}

	if (controls.initialError || !data || data?.length === 0) {
		return (
			<ContentLayout>
				<InfoBanner
					headline={ts('stav.chyba.zatim-tu-nic-neni')}
					text={ts('stav.chyba.nenasli-jsme-zadne-udaje')}
				/>
			</ContentLayout>
		);
	}

	return (
		<ContentLayout>
			<LayoutGap gap="xl">
				{data.map((agenda) => (
					// TODO: This list can be quite large (~ couple of MB), virtual list might be needed here
					<section key={agenda.kodAgendy}>
						<h2 className="text-headline-s!">
							{agenda.nazevAgendy}{' '}
							<span className="text-body-s! text-(--text-tertiary)">
								{ts('kod-agendy')} {agenda.kodAgendy}
							</span>
						</h2>
						<ul className="gov-list--plain">
							{agenda.children.map((ais) => (
								<li key={ais.kodAis}>
									<AgendaItem ais={ais}>
										<LayoutGap gap="s">
											{ais?.nazevAis}{' '}
											<span className="text-body-s text-(--text-secondary)">
												{ts('kod-agendoveho-i-s')} {ais?.kodAis}
											</span>
										</LayoutGap>
									</AgendaItem>
									{expandedAis === ais.kodAis &&
										(aisData ? (
											<AisView
												code={code}
												aisData={aisData}
											/>
										) : (
											<AisSkeleton />
										))}
								</li>
							))}
						</ul>
					</section>
				))}
			</LayoutGap>
		</ContentLayout>
	);
};

AgendasView.displayName = 'AgendasView';
